import React from "react";
import RunView from "../Components/DocumentCrafting/Run/RunView";

const DocumentCraftingRunPage: React.FC = () => <RunView />;

export default DocumentCraftingRunPage;
